import { PopupAuthenticator } from '@ms/yammer-web-authenticators';
import Login from '@ms/yammer-web-components/dist/login';
import React, { FC } from 'react';

import { useLoginCallback } from './hooks';

interface PageLoginProps {
  readonly authenticator: PopupAuthenticator;
}

const PageLogin: FC<PageLoginProps> = ({ authenticator }) => {
  const loginCallback = useLoginCallback(authenticator);

  return <Login onClick={loginCallback} />;
};

export default PageLogin;
